import React, { useEffect, useState } from "react"

export default function Select2(props) {
    const [select, setSelect] = useState([])
    
    useEffect(() => {
        if (props.data.length !== 0) {
            setSelect(props.data)
        }
    }, [props.data])

    return (
        <div className={"col-12 " + props.col}>
            <div className="form-group">
                <label>{props.header}</label>
                <select 
                    onChange={(e) => props.handledOnChange(e)}
                    id="selectedData"
                    name="selectedData"
                    className="form-control select2 select2-success"
                    style={{ width: "100%" }}
                    value={props.year}
                >
                    <option value="DEFAULT">{props.TextInit}</option>
                    {select.map((element, index) => (
                        <option key={index} value={element.id}>
                            {element.description ? element.description : element.names}
                        </option>
                    ))}
                </select>
            </div>
        </div>
    )
}
